import { capitalize, Grid } from '@mui/material'
import dayjs from 'dayjs'
import Decimal from 'decimal.js'
import PropTypes from 'prop-types'
import React from 'react'
import {useSelector} from 'react-redux'
import { forexMath, toFixedIfNull } from '../../../../../helpers'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'
import {
	selectCloseReason,
	selectPositionDefaultItem,
	selectPositionInfo,
	selectTailDigitOfCurrency
} from '../../../../../store/redusers/positions/selectors'
import { selectMarginTradePlatform } from '../../../../../store/redusers/user/selectors'
import { AppOrderItem } from '../../../../AppOrderItem'

const SidebarPositionInfo = () => {
	const positionInfo = useSelector(selectPositionInfo)
	const myTrade = useSelector(selectPositionDefaultItem(positionInfo.positionType, positionInfo.positionId))
	const marginTrade = useSelector(selectMarginTradePlatform)
	const closeReason = useSelector(selectCloseReason)
	const tailDigitOfCurrency = useSelector(selectTailDigitOfCurrency)
	const { theme } = useDefaultComponentTools()
	let invTitle = 'Investment'
	if (marginTrade) {
		invTitle = 'Used Margin'
	}
	const getDate = (date) => {
		return  dayjs(date).format('DD.MM.YYYY')
	}
	const thisPnl = (new Decimal(myTrade.openPnl))
	let executionDatePop = getDate(myTrade.executionDate)
	let closePrice = forexMath.formatRateForTrade((myTrade.endRate != null)
		? myTrade.endRate : myTrade.executionEntryRate, myTrade)
	if (myTrade.realCloseReason === 'SL'){
		closePrice = myTrade.stopLoss
	} else if (myTrade.realCloseReason === 'TP'){
		closePrice = myTrade.takeProfit
	}
	if (myTrade.status === 'pendingOff') {
		executionDatePop = 'N/A'
		closePrice = 'N/A'
	}
	const closeDatePop = (myTrade.endDateClient !== null && myTrade.endDateClient !== undefined)
		? getDate(myTrade.endDateClient) : getDate(myTrade.endDate)
	const realCloseReason = (myTrade.realCloseReason === 'Manual' && closeReason === 1)
		? 'Auto' : myTrade.realCloseReason
	const openPrice = forexMath.formatRateForTrade(myTrade.executionEntryRate, myTrade)
	const pnl = toFixedIfNull(thisPnl, tailDigitOfCurrency)
	const invValue = toFixedIfNull(myTrade.amount, tailDigitOfCurrency)
	const tradeSize = forexMath.getTradeSizeValueStr(myTrade.lotSize, myTrade.leverage)

	return (
		<Grid container sx={{ borderBottom: '1px solid #F6F7F9', mb: 4, pb: 2 }}>
			<AppOrderItem title={'Order ID'} value={myTrade.id}/>
			<AppOrderItem title={'PNL'} value={pnl}/>
			<AppOrderItem title={'Open Date'} value={executionDatePop}/>
			<AppOrderItem title={'Close Date'} value={closeDatePop}/>
			<AppOrderItem title={'Open Price'} value={openPrice}/>
			<AppOrderItem title={'Close Price'} value={closePrice}/>
			<AppOrderItem title={invTitle} value={invValue} currency={myTrade.currency}/>
			<AppOrderItem title={'Trade Size'} value={tradeSize}/>
			<AppOrderItem title={'Lots'} value={myTrade.leverage}/>
			<AppOrderItem title={'Direction'} value={capitalize(myTrade.position)}
				inputSx={{color: myTrade.position === 'sell' ? theme.palette.red : theme.palette.green}}/>
			<AppOrderItem title={'Close Reason'} value={realCloseReason}/>
		</Grid>
	)
}

SidebarPositionInfo.propTypes = {
	myTrade: PropTypes.object
}
export default SidebarPositionInfo
